import React, {
  FC,
  MouseEventHandler,
  useCallback,
  ReactNode,
  useEffect,
} from 'react';
import '../../styles/message.scss';
interface MessageProps {
  content: string | ReactNode;
  duration?: number;
  type?: string;
}
const Message: FC<MessageProps> = ({ content, duration = 2000, type }) => {
  // 开关控制：默认true,调用时会直接打开
  const [visible, setVisible] = React.useState(true);
  // 关闭消息提示
  const handleClose = useCallback<MouseEventHandler<HTMLDivElement>>((e) => {
    e.stopPropagation();
    setVisible(false);
  }, []);
  const startTimer = () => {
    if (duration > 0) {
      setTimeout(() => {
        setVisible(false);
      }, duration);
    }
  };
  const keydown = (e: any) => {
    if (e.keyCode === 27) {
      // esc关闭消息
      setVisible(false);
    }
  };
  useEffect(() => {
    startTimer();
    document.addEventListener('keydown', keydown);
    return document.removeEventListener('keydown', keydown);
  }, []);
  return (
    <div>
      {visible ? (
        <div className={`pit-tips pit-${type || 'info'}-tips`}>
          <div className="pit-tips-container">
            <div>{content}</div>
          </div>
          <div className="pit-close-btn" onClick={handleClose}></div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};
export default Message;
